var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page-header"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"header-content"},[_c('h1',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))])])])]),_c('div',{staticClass:"page-content container-fluid"},[_vm._t("default")],2),_c('div',{staticClass:"last-component"})])
}
var staticRenderFns = []

export { render, staticRenderFns }